import React, { useContext } from "react";

import { AiFillEdit } from "react-icons/ai";
import AuthContext from "context/AuthContext";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UserVerificationManager = () => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const manager = user?.permission?.find((e) => e.manager === "category") ?? {};
  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE]  bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                {t("O_VERIFICATION_STEPS")}
              </th>
              <th className="text-center">{t("O_ACTION")}</th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
              <td className="py-4 px-6 border-r">Multiple choice questions</td>
              {(manager?.add || user?.role === "admin") && (
                <td className="py-4 px-6 border-l">
                  <div className="">
                    <ul className="flex justify-center">
                      <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                        <NavLink to={`/user-verification-manager/mcq-list`} title={t("O_EDIT")}>
                          {" "}
                          <AiFillEdit className="w-5 h-5 text-slate-600" />
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </td>
              )}
            </tr>
            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
              <td className="py-4 px-6 border-r">Connect your socials</td>
              {(manager?.add || user?.role === "admin") && (
                <td className="py-4 px-6 border-l">
                  <div className="">
                    <ul className="flex justify-center">
                      <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                        <NavLink to={`/user-verification-manager/social-connections`} title={t("O_EDIT")}>
                          {" "}
                          <AiFillEdit className="w-5 h-5 text-slate-600" />
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserVerificationManager;
